import { currencyFormatter } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";
import { _CO, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/function";

export const ColumnBuilder = () => {
  const buildColumns = () => {
    const generatedColumns = [];

    generatedColumns.push(
      ...createColumn([
        {
          headerName: "",
          field: "group",
          width: 300,
          rowGroup: true,
          hide: true,
          valueGetter: (params) => {
            return params.data.group;
          },
        },
        {
          headerName: "",
          field: "rowName",
          flex: 2,
        },
      ]),
    );

    for (let i = 1; i <= 12; i++) {
      const fiscalMonthIndex = _CO[i];
      generatedColumns.push(
        ...createColumn([
          {
            headerName: _MONTHS[fiscalMonthIndex],
            field: `${fiscalMonthIndex}`,
            editable: true,
            headerClass: "month-header",
            flex: 1,
            type: "rightAligned",
            valueFormatter: (params) => {
              return currencyFormatter(params.value, "", 0);
            },
          },
        ]),
      );
    }

    return generatedColumns;
  };

  return buildColumns();
};
